<template>
  <div class="card shadow p-md-2">
    <div class="card-body">
      <div class="d-flex flex-column flex-md-row justify-content-between">
        <div class="d-flex flex-column my-auto product-name-width">
          <div class="ms-auto d-md-none">
            <v-loader-icon
              :action="removeQuote"
            />
          </div>
          <div class="lead fw-bold mb-2">
            <v-highlight
              :product-id="quote.productId"
              :product-name="getProductName(quote.productId)"
            />
          </div>
          <div class="lead">
            N° {{ quote.reference }}
          </div>
        </div>
        <div class="lead fw-bold my-auto">
          {{ price | formatPrice(true) }} €
        </div>
        <div class="my-auto">
          <v-download
            :action="downloadQuote"
          />
        </div>
        <div class="my-md-auto mt-3">
          <v-loader
            title="Reprendre"
            icon="arrow-white-right"
            class="w-100"
            :class="{ 'invisible': cannotResumeQuote }"
            :button-disabled="cannotResumeQuote"
            :next="goToQuote"
          />
          <v-loader
            class="d-md-none mt-2 w-100"
            title="Télécharger"
            color="blue-700"
            icon="download-white"
            :next="downloadQuote"
          />
        </div>
        <div class="my-auto d-none d-md-flex">
          <v-loader-icon
            :action="removeQuote"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash-es';
import { mapGetters } from 'vuex';

import DownloadButton from '@/components/common/helpers/DownloadButton.vue';
import LoaderIcon from '@/components/common/helpers/LoaderIcon.vue';
import ProductHighlight from '@/components/common/helpers/ProductHighlight.vue';

export default {
  components: {
    'v-highlight': ProductHighlight,
    'v-download': DownloadButton,
    'v-loader-icon': LoaderIcon,
  },
  props: {
    quote: {
      type: Object,
      required: true,
      default: () => ({
        productId: 1,
        priceDetails: {},
      }),
    },
  },
  computed: {
    ...mapGetters({ products: 'rater/products' }),
    price() {
      return this.quote.annualPremium
        || this.quote.premiumTaxesIncl
        || 0;
    },
    cannotResumeQuote() {
      const blockTelework = this.quote.productId === 42
        && get(this.quote, 'risk.employeesBracket.code', 'SALARIES_301_TO_500') === 'SALARIES_301_TO_500';
      return this.quote.derogation || !this.quote.delegation || blockTelework;
    },
  },
  methods: {
    goToQuote() {
      if (this.quote.derogation || !this.quote.delegation) {
        return Promise.resolve();
      }
      window.location.assign(`${import.meta.env.VITE_WIDGET_URL}/edition?orderId=${this.quote.orderId}`);
      return Promise.resolve();
    },
    async removeQuote() {
      const subscription = this.quote;
      await this.$store.dispatch('orders/remove', subscription);
      const companyId = get(this, '$store.state.company.companyId');
      if (companyId) {
        await this.$store.dispatch('orders/setOrders', companyId);
      }
    },
    async downloadQuote() {
      return this.$store.dispatch('download/downloadSubscriptionPreview', this.quote.id);
    },
    getProductName(productId) {
      return (this.products.find(({ id }) => id === productId) || { name: 'Contrat' })
        .name;
    },
  },
};
</script>
<style scoped>
@media screen and (min-width: 576px) {
  .product-name-width {
    min-width: 350px;
  }
}
</style>
